import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-up",
  "use": "icon-up-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-up\"><defs><style type=\"text/css\"></style></defs><path d=\"M556 333.6l280.5 280.5c10.8 10.8 10.8 28.4 0 39.2-10.8 10.8-28.4 10.8-39.2 0L536.2 392.1 275.1 653.3c-10.8 10.8-28.4 10.8-39.2 0-10.8-10.8-10.8-28.4 0-39.2l280.5-280.5c5.4-5.4 12.6-8.1 19.8-8.1 7.2 0 14.4 2.6 19.8 8.1z\" fill=\"#565860\" p-id=\"2275\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/up.svg
// module id = S+/b
// module chunks = 156